import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "clojure",
  extensions: [".clj", ".cljs", ".cljc", ".edn"],
  aliases: ["clojure", "Clojure"],
  loader: () => import('./clojure.js')
});
